import React, { useEffect, useMemo, useState } from "react";

import { Editor } from "@hugerte/hugerte-react";

import { usePermissions } from "hooks/permission";

import { DropdownGlobal } from "components/DropdownGlobal";

import { customerTemplateService } from "services/costumerTemplate";
import { editorInit } from "services/utils/editor.config";

import { FORMS_HEARING } from "utils/entities/permission";
import { useQuery } from "utils/get";

import { IAta } from "./interface";
import {
  Container,
  FooterContainer,
  ButtonContainer,
  ContainerTiny,
} from "./styles";
import Button from "../../../../components/Button";
import { ContainerTemplate } from "../Transcription/styles";

const Ata: React.FC<IAta> = ({
  buttonTitle,
  buttonFunction,
  disabledButton,
  ataRef,
  ata,
  ataText,
  setAtaText,
  setSelectTemplate,
  selectTemplate,
  modelList,
  loadingAba,
  setChangedTextAta,
  submited,
  setSubmited,
}) => {
  const query = useQuery();

  const hearingId = query.get("hearingId");
  const hearingFileId = query.get("hearingFileId");

  const { export: exportDownloads } = usePermissions(
    FORMS_HEARING.HEARING_FILE,
  );
  const editorConfig = useMemo(
    () => editorInit(exportDownloads, true),
    [exportDownloads],
  );

  const firstAta = useMemo(() => ata?.[0], [ata]);
  const [localTinyText, setLocalTinyText] = useState(firstAta?.content || "");
  const tinyText = ataText ?? localTinyText;
  const updateTinyText = setAtaText ?? setLocalTinyText;

  const selectedModel =
    firstAta && modelList.length
      ? modelList.find((x) => x.id === firstAta.customerTemplateId)
      : { name: "Selecione o modelo", template: "" };
  const hasSelectedTemplate = Boolean(selectTemplate?.id || selectedModel?.id);
  const disableMinuteFields = !hasSelectedTemplate;
  const saveButtonDisabled = disabledButton || disableMinuteFields;

  useEffect(() => {
    if (selectedModel?.id) {
      setSelectTemplate(selectedModel);
    }
  }, [selectedModel?.id]);

  useEffect(() => {
    if (ataText === undefined) {
      setLocalTinyText(firstAta?.content || "");
    }
  }, [ataText, firstAta?.content]);

  useEffect(() => {
    (async () => {
      //if (changedTextAta) {
      if (!(firstAta && firstAta.id && firstAta.content)) {
        if (selectTemplate && selectTemplate?.id) {
          const { body } =
            await customerTemplateService.SetKeywordsByHearingFile({
              hearingFileId: Number(hearingFileId),
              customerTemplateId: selectTemplate?.id,
            });

          setChangedTextAta(false);
          updateTinyText(body);
        }
      }
      //}
    })();
  }, [selectTemplate?.id, hearingId]);

  const onClick = () => {
    if (saveButtonDisabled) return;

    setSubmited && setSubmited(true);
    setChangedTextAta(true);
    buttonFunction();
  };

  return (
    <Container>
      {!loadingAba ? (
        <ContainerTemplate>
          <DropdownGlobal
            labelName="Modelo"
            options={modelList}
            defaultValue={
              selectTemplate ? selectTemplate?.name : selectedModel?.name
            }
            showDefaultValue
            width="320px"
            setSelected={setSelectTemplate}
            wantAnObject
            disabled={firstAta?.content && selectedModel}
            error={!selectTemplate?.template && submited}
          />
        </ContainerTemplate>
      ) : (
        <ContainerTemplate></ContainerTemplate>
      )}
      <ContainerTiny>
        <Editor
          onInit={(_, editor) => (ataRef ? (ataRef.current = editor) : null)}
          init={editorConfig}
          disabled={disableMinuteFields}
          // initialValue={firstAta && firstAta ? firstAta.content : ""}
          onKeyDown={(event) => {
            if ((event.ctrlKey || event.metaKey) && event.key === "c") {
              event.preventDefault();
              alert("Não é possivel copiar esse texto");
            }
          }}
          value={tinyText}
          onEditorChange={(e) => {
            updateTinyText(e);
          }}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
        />
      </ContainerTiny>
      <FooterContainer>
        <ButtonContainer>
          <Button
            disabled={saveButtonDisabled}
            onClick={onClick}
          >
            {buttonTitle}
          </Button>
        </ButtonContainer>
      </FooterContainer>
    </Container>
  );
};

export default Ata;
